// external
import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";

import SwitchOnOff from "components/common/tools/SwitchOnOff";

function PushNotificationSwitch({ t }) {
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    if (window?.WonderPush) {
      getSubscribeState();
    }
  }, []);

  const getSubscribeState = () => {
    window.WonderPush.push(() => {
      window.WonderPush.isSubscribedToNotifications().then((isSubscribed) => {
        setSubscribed(isSubscribed);
      });
    });
  };

  const onChangeSubscribe = (state, event) => {
    if (state) {
      window.WonderPush.subscribeToNotifications(event);
    } else {
      window.WonderPush.unsubscribeFromNotifications();
    }
  };

  if (!window?.WonderPush) return null;

  return (
    <div className="editor-form-row editor-form-row-inline">
      <div className="editor-form-input">
        <SwitchOnOff
          name="notifications-switch"
          onChange={(value, event) => onChangeSubscribe(value, event)}
          checked={subscribed}
          size="sm"
        />
      </div>
      <div className="editor-form-label">{t("enable_notifications")}</div>
    </div>
  );
}

PushNotificationSwitch.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation("admin-profile")(PushNotificationSwitch);
